import { supabase } from '../lib/supabase';

// Llama a una Edge Function de Supabase con la sesión del usuario.
// Lanza un Error con `status` y `code` (p. ej. 403 / 'AI_LIMIT_REACHED') si falla.
export const callFunction = async (name, body = {}) => {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (!error) return data;

  let payload = null;
  try {
    payload = await error.context?.json();
  } catch {
    // respuesta sin JSON
  }
  const err = new Error(payload?.message || 'Error de conexión con el servidor');
  err.status = error.context?.status;
  err.code = payload?.error;
  throw err;
};
